// Morning & Mūn — Theme JS

// Scroll fade-up animation
document.addEventListener('DOMContentLoaded', function () {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    },
    { threshold: 0.12 }
  );

  document.querySelectorAll('.fade-up').forEach((el) => observer.observe(el));

  // Stagger children within grids
  document
    .querySelectorAll('.ingredients-grid, .testimonials-grid, .ritual-steps, .results-grid')
    .forEach((grid) => {
      grid.querySelectorAll('.fade-up').forEach((el, i) => {
        el.style.transitionDelay = `${i * 0.1}s`;
      });
    });
});


// Contact form lightweight spam protection
document.addEventListener('DOMContentLoaded', function () {
  const contactForm = document.querySelector('form.contact-form');
  if (!contactForm) return;

  const loadedAtInput = contactForm.querySelector('#ContactFormLoadedAt');
  const honeypotInput = contactForm.querySelector('#ContactFormWebsite');
  const spamMessage = contactForm.querySelector('[data-contact-spam-message]');
  const loadedAt = Date.now();

  if (loadedAtInput) loadedAtInput.value = String(loadedAt);

  contactForm.addEventListener('submit', function (event) {
    const submittedTooFast = Date.now() - loadedAt < 3500;
    const honeypotFilled = honeypotInput && honeypotInput.value.trim() !== '';

    if (honeypotFilled || submittedTooFast) {
      event.preventDefault();
      if (spamMessage) spamMessage.hidden = false;
    }
  });
});
